import React from 'react';
import { Box } from '@mui/material';

/**
 * Componente wrapper para las tarjetas de jugadores con rankings
 * Aplica estilos de fondo según el tier del ranking del jugador
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Contenido a envolver
 * @param {Object|null} props.playerRanking - Objeto con tier y category del ranking, o null
 * @param {string} [props.playerRanking.tier] - Tier del ranking: "gold", "silver", "bronze", "red"
 * @param {string} [props.playerRanking.category] - Categoría del ranking: "mercado", "fantasy", "mister", "marca", "biwenger"
 * @param {string} [props.playerRanking.marketType] - Tipo de ranking de mercado: "up", "down", "value", o null
 * @param {number} props.size - Tamaño del componente (ancho)
 * @param {string} [props.className] - Clases CSS adicionales
 * @param {Object} [props.sx] - Estilos adicionales de MUI
 * @param {Function} [props.onClick] - Función onClick
 *
 */

const wrapperBaseStyles = {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    justifyContent: 'flex-start',
    display: 'flex',
};

const PlayerCardWrapper = ({ children, playerRanking, size, className, sx, onClick, ...props }) => {
    // Determinar la imagen de fondo según el tier del ranking
    const getCardImage = (tier) => {
        if (!tier) return null;
        return `${process.env.NEXT_PUBLIC_IMAGES}/cards/${tier}.png?width=${size * 1.5}&height=${size * 1.51 * 1.5}`;
    };

    const wrapperStyles = playerRanking
        ? {
              backgroundImage: `url(${getCardImage(playerRanking.tier)})`,
              height: size * 1.51,
              ...wrapperBaseStyles,
          }
        : {};

    return (
        <Box
            className={className}
            width={size * 1.1}
            top={props.top}
            onClick={onClick}
            sx={{
                cursor: onClick ? 'pointer' : 'default',
                ...wrapperStyles,
                ...sx,
            }}
        >
            {children}
        </Box>
    );
};

export default PlayerCardWrapper;
